import { Loader2, Trash2, X, CheckSquare, Sparkles } from "lucide-react";

export const SelectionBar = ({ count, noun, busy, onRemove, onClear, onSelectAll, onBuildMix, hidden = 0, label = null, children }) => {
  if (!count) return null;
  return (
    <div data-testid="selection-bar"
      className="fixed bottom-28 left-1/2 z-40 flex -translate-x-1/2 animate-rise items-center gap-2 rounded-full border border-zinc-200 bg-white/95 py-2 pl-5 pr-2 shadow-[0_8px_30px_rgba(0,0,0,0.12)] backdrop-blur-md">
      <span className="mr-2 text-sm font-medium" data-testid="selection-count">{label || `${count} ${noun}${count === 1 ? "" : "s"} selected`}{hidden > 0 && <span className="ml-1 text-xs font-normal text-zinc-500" data-testid="selection-hidden" title="Selected on another page, sort or filter — still included in actions">· {hidden} not shown</span>}</span>
      {onSelectAll && (
        <button onClick={onSelectAll} data-testid="selection-select-all" className="flex h-9 items-center gap-1.5 rounded-full px-3 text-xs text-zinc-600 hover:bg-zinc-100">
          <CheckSquare size={14} />Select all
        </button>
      )}
      {children}
      {onBuildMix && (
        <button onClick={onBuildMix} data-testid="selection-build-mix" title="Open the Playlist Builder with the selected songs as seeds"
          className="flex h-9 items-center gap-1.5 rounded-full border border-amber-300 bg-amber-50 px-3 text-xs font-medium text-amber-900 hover:border-amber-600">
          <Sparkles size={14} />Build a mix
        </button>
      )}
      {onRemove && (
        <button onClick={onRemove} disabled={busy} data-testid="selection-remove-button"
          className="flex h-9 items-center gap-1.5 rounded-full bg-red-600 px-4 text-xs font-medium text-white transition-colors hover:bg-red-700 disabled:opacity-50">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Trash2 size={14} />}Remove from library
        </button>
      )}
      <button onClick={onClear} data-testid="selection-clear" title="Clear selection" className="flex h-9 w-9 items-center justify-center rounded-full text-zinc-400 hover:bg-zinc-100 hover:text-zinc-900"><X size={15} /></button>
    </div>
  );
};

export const REMOVE_NOTE = "Uploaded files are deleted. OneDrive and Plex songs are only removed from this library (your files stay untouched) and won't come back on the next sync.";
